import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import Icon from "../../icons";
import { cn } from "../../utils";
const PLACEHOLDER_SRC = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D";
const Image = ({ src, alt, inView = true, className }) => {
    const [hasLoaded, setHasLoaded] = useState(false);
    const setLoaded = useCallback(() => {
        if (inView)
            setHasLoaded(true);
    }, [inView]);
    return (_jsxs("div", { className: "relative h-full w-full", children: [!hasLoaded && _jsx(Icon, { name: "cb-loading-spin", className: "-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 transform" }), _jsx("img", { src: inView ? src : PLACEHOLDER_SRC, alt: alt, "data-src": src, className: cn("h-full w-full object-cover", className), onLoad: setLoaded })] }));
};
export default Image;
